import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 -mt-8 relative z-20">
      <div className="bg-background-50 rounded-xl p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleClick(cat.slug)}
              className="px-4 py-2 rounded-full bg-background-100 hover:bg-primary-100 hover:text-primary-700 text-foreground-700 text-sm font-medium transition-all whitespace-nowrap"
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}